class WebSocketService {
  constructor(url, token, messageHandler, closeHandler, errorHandler) {
    this.url = url;
    this.token = token;
    this.messageHandler = messageHandler;
    this.closeHandler = closeHandler;
    this.errorHandler = errorHandler;
    this.socket = null;

    this.pongTimeout = null;
    this.pingInterval = null;
    this.pingIntervalTime = 8000; // 多少秒发送一次Ping，可以根据实际需要调整
    this.pongTimeoutTime = 20000; // 多少秒后未收到Pong则认为超时
  }

  connectWebSocket() {
    console.log(`#### connectWebSocket, token=${this.token}`);
    this.socket = new WebSocket(`${this.url}?token=${this.token}`);

    this.socket.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      const timestamp = new Date().toISOString();
      if (msg.msgType != "Ping" && msg.msgType != "Pong") {
        console.log(`[${timestamp}] #### RECV: `, msg);
      }
      // 如果收到了消息，则认为连接正常，清除掉pongTimeout
      clearTimeout(this.pongTimeout);
      if (msg.msgType === 'Pong') {
        return;
      }
      this.messageHandler(msg);
    };

    this.socket.onclose = (event) => {
      console.log(`######## WebSocket closed, event=${event}`);
      this.closeHandler(event);

      // 停止Ping定时器
      this.stopPing();

      // 添加延时，防止重连太频繁
      setTimeout(() => {
        this.reconnectWebSocket();
      }, 3000); // 3000 毫秒延时
    };

    this.socket.onerror = (event) => {
      console.log(`######## WebSocket error, event=${event}`);
      this.errorHandler(event);

      // 停止Ping定时器
      this.stopPing();

      // 添加延时，防止重连太频繁
      setTimeout(() => {
        this.reconnectWebSocket();
      }, 3000); // 3000 毫秒延时
    };

    this.socket.onopen = (event) => {
      console.log(`#### WebSocket opened, event=${event}`);

      // 启动Ping定时器
      this.startPing();
    };
  }

  reconnectWebSocket() {
    console.log(`#### reconnectWebSocket, event=${this.token}, socket.readyState=${this.socket.readyState}`);
    if (this.token && this.socket.readyState === 3) { // WebSocket.CLOSED
      this.connectWebSocket();
    }
  }

  startPongTimeout() {
    clearTimeout(this.pongTimeout); // 清除之前的定时器
    this.pongTimeout = setTimeout(() => {
      const timestamp = new Date().toISOString();
      console.log(`[${timestamp}] #### Pong timeout, closing socket`);
      this.socket.close(); // 超时未收到Pong，则关闭连接
    }, this.pongTimeoutTime);
  }

  startPing() {
    this.pingInterval = setInterval(() => {
      if (this.socket.readyState === WebSocket.OPEN) {
        // console.log('#### Sending Ping');
        this.sendMessage({ msgType: 'Ping' });
        this.startPongTimeout();
      }
    }, this.pingIntervalTime);
  }

  stopPing() {
    clearInterval(this.pingInterval);
    clearTimeout(this.pongTimeout);
  }

  sendMessage(msg) {
    const customerWebsiteUserToken = localStorage.getItem('customer_website_user_token');
    if (customerWebsiteUserToken && customerWebsiteUserToken.length > 0) {
      msg.customerWebsiteUserToken = customerWebsiteUserToken;
    }

    this.socket.send(JSON.stringify(msg));
    const timestamp = new Date().toISOString();
    if (msg.msgType != "Ping" && msg.msgType != "Pong") {
      console.log(`[${timestamp}] #### SEND: `, msg);
    }
  }

  // 当前 WebSocket 是否处于 OPEN 状态. 用于"自动已读"前置条件判断: 离线时不应触发上报.
  isOpen() {
    return !!this.socket && this.socket.readyState === WebSocket.OPEN;
  }
}

export default WebSocketService;
